import { render } from "./Home.vue?vue&type=template&id=76600ff6&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=76600ff6&lang=less&scoped=true"

import exportComponent from "C:\\REPOS\\pwd-reset\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76600ff6"]])

export default __exports__